import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const fmt = v => '₹' + Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 });

export default function RevenueChart({ data }) {
  if (!data || data.length === 0) return (
    <div className="card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '180px', color: 'var(--light)', fontSize: '13px' }}>
      No data for selected range
    </div>
  );
  return (
    <div className="card">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <div className="card-title" style={{ margin: 0 }}>Revenue & bills trend</div>
        <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: 'var(--muted)' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ width: '14px', height: '3px', background: 'var(--green)', display: 'inline-block', borderRadius: '2px' }} />Revenue
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ width: '14px', height: '3px', background: 'var(--blue)', display: 'inline-block', borderRadius: '2px' }} />Bills
          </span>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--grid)" />
          <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={d => d.slice(5).replace('-', '/')} />
          <YAxis yAxisId="rev" tickFormatter={v => '₹' + (v/1000).toFixed(0) + 'k'} tick={{ fontSize: 10 }} width={52} />
          <YAxis yAxisId="bills" orientation="right" tick={{ fontSize: 10 }} width={32} />
          <Tooltip formatter={(v, name) => [name === 'Revenue' ? fmt(v) : v, name]} />
          <Line yAxisId="rev"   type="monotone" dataKey="total_revenue" stroke="var(--green)" strokeWidth={2.5} dot={false} name="Revenue" />
          <Line yAxisId="bills" type="monotone" dataKey="total_bills"   stroke="var(--blue)" strokeWidth={2}   dot={false} name="Bills" strokeDasharray="4 3" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
